// Single source of truth for the UI version label shown next to the
// Tellipsis logo in every header (admin, reseller, user portal) and on
// the login / forgot-password screens. Bumping the version is a one-line
// edit here.
export const APP_VERSION = "2.0";
